var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { CaptionLarge, Dropdown, DropdownWidth, ButtonPrimary, ContentBox, H4 } from '@by-miles/bymiles-styles';
import { DataLayer } from '@by-miles/data-layer';
import { DynamicTitle } from '../DynamicTitle';
import { NCDStyle } from './NCDStyle';
import { eventSection } from '../../utils/event';
var ncdOptions = [];
for (var i = 0; i < 22; i++) {
    ncdOptions.push({ value: i, label: i === 21 ? '21+' : i });
}
var ncdSecondOptions = [
    { label: 'I’m currently insured on another car', value: 'S' },
    { label: 'I’m insured as a named driver on my spouse’s car', value: 'N' },
    { label: 'I’ve been insured as part of a company car scheme', value: 'C' },
    { label: 'I’ve been insured as part of the Motability scheme', value: 'M' },
    { label: 'I’ve been insured as part of a car club (e.g. Zipcar)', value: 'CC' },
    { label: 'None of these apply', value: 'X' },
];
var mobileUserAgentRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
export var NCD = function (_a) {
    var _b;
    var ncdProps = _a.ncdProps;
    var _c = useState(false), NCDError = _c[0], setNCDError = _c[1];
    var _d = useState(false), NCDError2 = _d[0], setNCDError2 = _d[1];
    var _e = useState(false), NCDError3 = _e[0], setNCDError3 = _e[1];
    var updateState = ncdProps.updateState, updateDataState = ncdProps.updateDataState, ncd = ncdProps.ncd, NCDStep = ncdProps.NCDStep, step = ncdProps.step, other_vehicle_relationship = ncdProps.other_vehicle_relationship, other_vehicle_ncd = ncdProps.other_vehicle_ncd, updateStepAndNCDStep = ncdProps.updateStepAndNCDStep, isQQPage = ncdProps.isQQPage;
    useEffect(function () {
        DataLayer.customEvent({
            eventName: 'ncd',
            eventType: 'virtual page view',
            section: eventSection(isQQPage),
        });
    }, []);
    var handleNCDSelect = function (step, value) {
        setNCDError(false);
        if (step === 'ncd') {
            updateDataState({ stateName: 'ncd', value: value });
        }
        else if (step === 'other_vehicle_relationship') {
            setNCDError2(false);
            updateDataState({ stateName: 'other_vehicle_relationship', value: value });
        }
        else if (step === 'other_vehicle_ncd') {
            setNCDError3(false);
            updateDataState({ stateName: 'other_vehicle_ncd', value: value });
        }
    };
    var handleNCDContinue = function () {
        if (ncd === null) {
            setNCDError(true);
            return false;
        }
        if (ncd === 0 && NCDStep === 0) {
            if (updateStepAndNCDStep) {
                updateStepAndNCDStep();
            }
            else {
                updateState({ stateName: 'NCDStep', value: 1 });
                updateState({ stateName: 'step', value: 3 });
            }
        }
        else if (ncd === 0 && NCDStep === 1) {
            if (!other_vehicle_relationship) {
                setNCDError2(true);
                return false;
            }
            else {
                updateState({ stateName: 'NCDStep', value: 2 });
            }
        }
        else {
            if (NCDStep === 2 && other_vehicle_ncd === null) {
                setNCDError3(true);
                return false;
            }
            else {
                updateState({ stateName: 'step', value: 4 });
                DataLayer.customEvent({
                    eventName: 'submit ncd',
                    eventType: 'button click',
                    section: eventSection(isQQPage),
                });
            }
        }
    };
    return (_jsxs(NCDStyle, __assign({ NCDStep: NCDStep, isQQPage: isQQPage }, { children: [_jsx("div", __assign({ className: "title-wrapper" }, { children: _jsx(DynamicTitle, { className: "enter-details-title", isQQPage: isQQPage, title: _jsx("span", { children: "Tell us a little about yourself." }) }) })), _jsx(ContentBox, __assign({ isQQPage: isQQPage, className: "content-box" }, { children: _jsxs(_Fragment, { children: [step === 2 && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title" }, { children: _jsx(H4, { children: "How many years of No Claims Discount do you have?" }) })), _jsx(CaptionLarge, __assign({ className: "claims-caption" }, { children: "This must be on a personal car in the UK in the last 24 months." })), _jsx("div", __assign({ className: "dropdown ".concat(NCDError ? 'error' : '') }, { children: _jsx(Dropdown, { handleDropdownChange: function (option) { return handleNCDSelect('ncd', option.value); }, options: ncdOptions, placeholder: "Select", isMobile: mobileUserAgentRegex.test(navigator.userAgent), preFilled: ncd ? ncd : ncd === 0 ? '0' : '' }) })), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { iconRight: "IconCaretRight", label: "continue", onClick: function () { return handleNCDContinue(); } }) }))] })), NCDStep === 1 && step === 3 && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title" }, { children: _jsx(H4, { children: "Do any of the following apply to you?" }) })), _jsx(CaptionLarge, __assign({ className: "claims-caption" }, { children: "Select the most relevant option." })), _jsx("div", __assign({ className: "dropdown larger ".concat(NCDError2 ? 'error' : '') }, { children: _jsx(Dropdown, { handleDropdownChange: function (option) { return handleNCDSelect('other_vehicle_relationship', option.value); }, options: ncdSecondOptions, placeholder: "Select", width: DropdownWidth.Medium, isMobile: mobileUserAgentRegex.test(navigator.userAgent), preFilled: other_vehicle_relationship
                                            ? (_b = ncdSecondOptions.find(function (option) { return option.value === other_vehicle_relationship; })) === null || _b === void 0 ? void 0 : _b.label
                                            : '' }) })), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { iconRight: "IconCaretRight", label: "continue", onClick: function () { return handleNCDContinue(); } }) }))] })), NCDStep === 2 && step === 3 && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title" }, { children: _jsx(H4, { children: "How many continuously claim-free years have you had on this other policy?" }) })), _jsx(CaptionLarge, __assign({ className: "claims-caption" }, { children: "Select the most relevant option." })), _jsx("div", __assign({ className: "dropdown ".concat(NCDError3 ? 'error' : '') }, { children: _jsx(Dropdown, { handleDropdownChange: function (option) { return handleNCDSelect('other_vehicle_ncd', option.value); }, options: ncdOptions, placeholder: "Select", isMobile: mobileUserAgentRegex.test(navigator.userAgent), preFilled: other_vehicle_ncd ? other_vehicle_ncd : '' }) })), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { iconRight: "IconCaretRight", label: "continue", onClick: function () { return handleNCDContinue(); } }) }))] }))] }) }))] })));
};
